import React from "react";
import { Trophy, TrendingUp, Activity, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from "@/components/ui/card";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ProfileCopy() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="46" id="featurecolumns" ref={sectionRef} className="relative min-h-[700px] w-full overflow-hidden bg-background flex items-center !p-0 !m-0 !h-[700px]">
      {}
      <div className="absolute inset-0 z-0">
        
        <div className="absolute bottom-[-20%] left-[-10%] h-[600px] w-[600px] rounded-full bg-primary-dark/30 opacity-30 blur-[100px]" />
        
      </div>

      <div className="container relative z-10 mx-auto px-6">
        <div className="grid gap-12 lg:grid-cols-[1.5fr_1fr] lg:items-center">
          
          <div className={`flex flex-col gap-8 transition-all duration-1000 ease-out ${isVisible ? "translate-x-0 opacity-100" : "-translate-x-10 opacity-0"}`}>
            <h2 className="text-4xl font-bold leading-tight !text-[hsl(0,0%,100%)] ![margin:0px_0px_0px_60px] md:text-5xl">
              Continued Legacy Success
            </h2>
            <div className="flex flex-col gap-4 text-lg md:text-xl text-black/90 leading-relaxed">
              <p className="!text-lg !text-[hsl(0,0%,100%)] ![margin:0px_0px_0px_60px]">“​​Over six years as CEO for a publicly listed company I was fortunate to be able to call on the New Mavericks team for support during this whole tenure. <br /><br />I would describe the support provided was to keep an overall balance and calmness while dealing with the demands, rigors and responsibilities that come with senior leadership positions in large organizations. <br /><br />I recommended their program to other senior executives, who also worked with them, and would highly recommend New Mavericks to other organizations and executives for developing mental capacity in keeping one grounded and prioritising thinking on the key leadership requirements.<br /><br />&nbsp;I am happy to speak with any senior executive about my experience with them.” <br /><br /><b data-ast-id="f:/src/pages/Clients/sections/ProfileCopy.tsx|sig:poltou" data-ast-start="2373" data-ast-end="2551">John Cullity Previous CEO EBOS Group Limited - 2018 - 2025</b><br /><br />NB Under John’s leadership EBOS accomplished total shareholder returns of 168%, significantly outperforming the market.</p>
              
            </div>
          </div>

          {}
          <div className={`relative flex flex-col items-center justify-center transition-all duration-1000 delay-300 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
            {}
            <div className="absolute top-1/2 left-1/2 -z-10 h-[120%] w-[120%] -translate-x-1/2 -translate-y-1/2 bg-gradient-to-b from-accent/20 to-transparent blur-3xl" />

            <div className="group relative w-full max-w-md transition-transform duration-500 hover:scale-[1.02]">
              <img src="https://newmavericks.com/wp-content/uploads/2026/03/John-Cullity.png" alt="Elite Performance Leadership" className="w-full h-auto rounded-lg shadow-strong object-cover ![margin:0px_20px_0px_0px]" />
            </div>
            <Button asChild size="lg" className="mt-8 bg-accent text-accent-dark hover:bg-accent-hover shadow-strong h-14 px-8 text-lg font-bold">
              
            </Button>
          </div>
        </div>
      </div>
    </section>;
}